export var getUniqueElemensById = function (entities) {
    return entities.filter(function (entity, index, self) {
        return self.findIndex(function (e) { return e.id === entity.id; }) === index;
    });
};
//# sourceMappingURL=getUniqueElemensById.js.map